import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text21 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {rightsPermitOther} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(rightsPermitOther) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <div className={styles.bold}>אישור זכויות רמ"י: </div>
          <span>{getBreakLinesTextShumaType3(rightsPermitOther)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text21;
